import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { ProductType } from 'src/easyclaim.api.client.typescript/src';
import FeedbackRating from 'src/easyclaim.app.components/FeedbackRating';
import CustomerConfigurationContext from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import styled from 'styled-components';

import { IconStar } from '../easyclaim.app.assets/index';
import { CenteredCircle, DetailContainer } from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';
import { UpdatedFeedbackScreen } from './UpdatedFeedbackScreen';

export interface FeedbackProps extends AppState {
	feedbackMaxLength: number;
}
export class Feedback extends ScreenComponent<FeedbackProps, {}> {
	constructor(props: FeedbackProps) {
		super(props);

		this.state = {};
	}

	public render() {
		const configuration = this.props.easyClaimCase && this.props.easyClaimCase._configuration;

		if (!configuration || !configuration.frontendSteps) {
			return;
		}

		return (
			<CustomerConfigurationContext.Consumer>
				{(ctx) => (
					<div className="main-container">
						{ctx?.configuration?.showUpdatedVerificationResults ? (
							<UpdatedFeedbackScreen
								feedbackMaxLength={this.props.feedbackMaxLength}
								appService={this.props.appService}
							/>
						) : (
							<>
								<h2 className="feedback-headline">
									{configuration.layout === ProductType.PolicyCheck ? (
										<FormattedMessage id="feedback.headline.policyCheck" />
									) : (
										<FormattedMessage id="feedback.headline" />
									)}
								</h2>
								<DetailContainer>
									{!!configuration &&
									!!configuration.additionalStyleFileName &&
									configuration.additionalStyleFileName.length > 0 ? (
										<div className="feedback-confirmation-icon"></div>
									) : (
										<CenteredCircle
											size="6rem"
											borderColor={theme.colors.success}
											borderStyle="solid"
											borderWidth="3px"
										>
											<StyledStarIcon />
										</CenteredCircle>
									)}
									<p className="feedback-description">
										<FormattedMessage id="feedback.description" />
									</p>
									<p className="feedback-rating">
										{configuration.layout === ProductType.PolicyCheck ? (
											<FormattedMessage id="feedback.rating.policyCheck" />
										) : (
											<FormattedMessage id="feedback.rating" />
										)}
									</p>
									<FeedbackRating
										{...this.props}
										feedbackMaxLength={this.props.feedbackMaxLength}
									/>
								</DetailContainer>
							</>
						)}
					</div>
				)}
			</CustomerConfigurationContext.Consumer>
		);
	}
}

const StyledStarIcon = styled(IconStar)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;
